import i18n from '../../../../i18n/i18n'

/**
 * last and news list of Messages global uses
 */
 export var validationMessage=[];

/**
 * 
 */
 const EntrykeysValidationMessage={
    InQuantityAndOutQuantity_OneOf:'InQuantityAndOutQuantity_OneOf',
    Quantity_Required:'Quantity_Required',
    Price_Required:'Price_Required',
    Material_Required:'Material_Required',
}


/**
 * dictionary contain message
 * flang is= fisrt language  , slanf is secound langauge 
 */
const EntryValidationMessage = {
    InQuantityAndOutQuantity_OneOf: {
        ar: "لا يمكن إدخال كمية داخلة وخارجة ضمن قيد واحد",
        en: "Specify in or out quantity, you can't enter both",
        es: "Especifique la cantidad de entrada o salida, no puede ingresar ambos",
    },
    Quantity_Required: {
        ar:"يجب إدخال إحدى حقول الكمية الداخلة أو الخارجة",
        en: "Quantity is required",
        es: "Se requiere cantidad",
    },
    Price_Required: {
        ar: "يجب إدخال حقل السعر",
        en: "Price is required",
        es: "Se requiere precio",
    },
    Material_Required: {
        ar: "يجب إدخال حقل المادة",
        en: "Item is required ",
        es: "Se requiere artículo",
    },
};


function pushMessage(key){
    let message= EntryValidationMessage[key][i18n.locale];
    if(!validationMessage.includes(message)){
        validationMessage.push(message);
    }
}

function intiLinkedRules(linkedRules){
    Object.keys(linkedRules).forEach(value => linkedRules[value] = true)
}

/**
 * Detected change entry row of founds table and enabled valid scenarios.
 *
 * @param {Object} entry entry object .
 * @param {Object} linkedRules dictionary of rules.
 * @return {Array} array of validationMessages.
 */
export function entryDetectedValidation(entry, linkedRules, skipValidation = {}){
    validationMessage=[];  //clear old =0
    intiLinkedRules(linkedRules);

    // prevenet inter income amount and outcome amount in the same time
    if(entry.in_quantity && entry.out_quantity){
        pushMessage(EntrykeysValidationMessage.InQuantityAndOutQuantity_OneOf);
        linkedRules.in_quantity = false;
        linkedRules.out_quantity = false;
    }
    // Material
    if(!entry.material_id){
        pushMessage(EntrykeysValidationMessage.Material_Required);
        linkedRules.material_id = false;
    }
    // Price
    if(!entry.price && !skipValidation.price){
        pushMessage(EntrykeysValidationMessage.Price_Required);
        linkedRules.price = false;
    }
    // MaterialAmount
    if(!entry.in_quantity && !entry.out_quantity){
        pushMessage(EntrykeysValidationMessage.Quantity_Required);
        linkedRules.in_quantity = false;
        linkedRules.out_quantity = false;
    }
    return validationMessage;
}